export const themeColor = "#006239";
export const projectTitle = "Citizen to Government Platform";

export const ENCRIPTION_PASSCODE = "cgp!l#at@f$orm54@7";
// export const apiURL = "https://cgp.hephzibahprojects.com";
export const apiURL = "https://egovern-api.skyniche.website";
// export const apiURL = "https://user.citigov.com.ng/backend";
// export const apiURL = "http://localhost:4000";